import React from 'react'
import { Navigate, NavLink, Route, Routes } from 'react-router-dom'

import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined'
import PortraitOutlinedIcon from '@mui/icons-material/PortraitOutlined';

import css from './settings.module.scss'
import { BootstrapTooltip } from '../../_ui/tooltip'
import OperatorsContainer from './operators/operatorsContainer'
import OperatorsMoodleContainer from './operatorsMoodle/operatorsMoodleContainer'

const Settings = (props: any) => {
    return (
        <div className={css.main}>
            <div className={css.header}>
                <div className={css.headerTitle}>Администрирование</div>

                <div className={css.headerBar}>
                    <BootstrapTooltip title="Операторы системы" placement="top" arrow>
                        <div className={css.navItem} style={{ marginRight: "-20px" }}>
                            <NavLink to="/main/settings/operators" className={({ isActive }) => isActive ? `${css.navItemActive}` : undefined}>
                                <div className={css.navItemLeft}>
                                    <div className={css.boxLeft}></div>
                                </div>

                                <div className={css.navItemData}>
                                    <PeopleAltOutlinedIcon />
                                </div>

                                <div className={css.navItemRight}>
                                    <div className={css.boxRight}></div>
                                </div>
                            </NavLink>
                        </div>
                    </BootstrapTooltip>

                    <BootstrapTooltip title="Операторы Moodle" placement="top" arrow>
                        <div className={css.navItem}>
                            <NavLink to="/main/settings/operatorsMoodle" className={({ isActive }) => isActive ? `${css.navItemActive}` : undefined}>
                                <div className={css.navItemLeft}>
                                    <div className={css.boxLeft}></div>
                                </div>

                                <div className={css.navItemData}>
                                    <PortraitOutlinedIcon />
                                </div>

                                <div className={css.navItemRight}>
                                    <div className={css.boxRight}></div>
                                </div>
                            </NavLink>
                        </div>
                    </BootstrapTooltip>
                </div>
            </div>

            <div className={css.body}>
                <Routes>
                    <Route path="/" element={<Navigate to="/main/settings/operators" />} />

                    <Route path="/operators" element={<OperatorsContainer />} />
                    <Route path="/operatorsMoodle" element={<OperatorsMoodleContainer />} />
                </Routes>
            </div>
        </div>
    )
}

export default Settings